import {
  anInsightStatus,
  mockInsightStatusesOperationQuery,
  mockInsightStatusesQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

// New, In Progress, & Closed Statuses are Built-In
// and are expected to exist for certain integration tests
export const NEW_STATUS_NAME = 'new';
export const NEW_STATUS_DISPLAY_NAME = 'New';

export const IN_PROGRESS_STATUS_NAME = 'inprogress';
export const IN_PROGRESS_STATUS_DISPLAY_NAME = 'In Progress';

export const CLOSED_STATUS_NAME = 'closed';
export const CLOSED_STATUS_DISPLAY_NAME = 'Closed';

const DEFAULT_STATUSES = [
  anInsightStatus({
    id: '0',
    name: NEW_STATUS_NAME,
    displayName: NEW_STATUS_DISPLAY_NAME,
    source: 'jask',
  }),
  anInsightStatus({
    id: '1',
    name: IN_PROGRESS_STATUS_NAME,
    displayName: IN_PROGRESS_STATUS_DISPLAY_NAME,
    source: 'jask',
  }),
  anInsightStatus({
    id: '2',
    name: CLOSED_STATUS_NAME,
    displayName: CLOSED_STATUS_DISPLAY_NAME,
    source: 'jask',
  }),
];

export const CUSTOM_STATUS = {
  id: '4',
  // "name" and "displayName" always match in the response for custom statuses
  name: 'Custom Status',
  displayName: 'Custom Status',
  description: 'custom status description',
  source: 'user',
};

export const insightStatusesQuery = {
  __typename: 'Query',
  insightStatuses: [
    ...DEFAULT_STATUSES,
    anInsightStatus({
      ...CUSTOM_STATUS,
    }),
  ],
};

export const insightStatusesQuery_create = {
  ...insightStatusesQuery,
  insightStatusInProgressEnabled: true,
};

export const handlers = [
  mockInsightStatusesOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightStatusInProgressEnabled: true,
          insightStatuses: [
            anInsightStatus({
              id: '0',
              name: NEW_STATUS_NAME,
              displayName: NEW_STATUS_DISPLAY_NAME,
              source: 'jask',
            }),
            anInsightStatus({
              id: '1',
              name: IN_PROGRESS_STATUS_NAME,
              displayName: IN_PROGRESS_STATUS_DISPLAY_NAME,
              source: 'jask',
            }),
            anInsightStatus({
              id: '2',
              name: CLOSED_STATUS_NAME,
              displayName: CLOSED_STATUS_DISPLAY_NAME,
              source: 'jask',
            }),
          ],
        },
      });
    }
  ),
  mockInsightStatusesQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightStatuses: DEFAULT_STATUSES,
        },
      });
    }
  ),
];
